import React, { useEffect, useState } from 'react';
import SelectionList from '../../../shared/components/SelectionList';
import { useQuery } from '@apollo/client';
import GET_MAXIMUM_PROGRAM_YEAR from '../../queries/getMaximumProgramYear';
import SelectionCheckbox from '../SelectionCheckbox';

/**
 * @typedef {object} ProgramYearSelectionProps
 * @property {Object} [appraisalProgramYear]
 * @property {(appraisalProgramYear: { label: string, value: number | string } | Array<{ label: string, value: number | string }> | null) => void} [setAppraisalProgramYear]
 * @property {(programYearMax: number) => void} [setProgramYearMax]
 * @property {boolean} includeHigherProgramYears
 * @property {(includeHigherProgramYears: boolean) => void} setIncludeHigherProgramYears
 */

/**
 * @param {ProgramYearSelectionProps} props
 */
const ProgramYearSelection = props => {
  const {
    appraisalProgramYear,
    setAppraisalProgramYear,
    setProgramYearMax,
    includeHigherProgramYears,
    setIncludeHigherProgramYears
  } = props;

  const [programYearOptions, setProgramYearOptions] = useState([]);

  const { data, loading } = useQuery(GET_MAXIMUM_PROGRAM_YEAR);

  useEffect(() => {
    const newProgramYearMax = data && data.maximumProgramYear;
    if (newProgramYearMax) {
      const options = [];
      for (let i = 1; i <= newProgramYearMax; i++) {
        options.push({
          label: i.toString(),
          value: i
        });
      }
      setProgramYearOptions(options);
    }

    setProgramYearMax(newProgramYearMax);
  }, [data, setProgramYearMax]);

  return (
    <div className='appraisal-view-customization__section'>
      <SelectionList
        key={appraisalProgramYear}
        id='select-program-year'
        showInputEndAdornment={false}
        allowAutocomplete={false}
        label='Program Year'
        onSelectHandler={setAppraisalProgramYear}
        selectedValue={appraisalProgramYear}
        list={programYearOptions}
        required
        placeholder='Select a Program Year'
        loading={loading}
      />
      <SelectionCheckbox
        id='select-include-higher-ProgramYears'
        label={
          <>
            Include the selected year as well as higher years.
            <br />
            Note: Data will not be a one to one comparison.
          </>
        }
        checked={includeHigherProgramYears}
        setChecked={setIncludeHigherProgramYears}
      />
    </div>
  );
};

export default ProgramYearSelection;
